import { useSearchParams, Link } from "react-router-dom";
import { Trophy } from "lucide-react";

const LEVEL_LABELS = { L0: "Quarter-Final", L1: "Semi-Final", L2: "Final", L3: "Bronze Match" };
const LEVEL_NEXT   = { L0: "Semi-Final", L1: "Final" };

export default function WinnerShare() {
  const [params] = useSearchParams();

  const name       = params.get("name")    || "Winner";
  const score      = params.get("score")   || "0";
  const oppName    = params.get("opp")     || "Opponent";
  const oppScore   = params.get("oscore")  || "0";
  const level      = params.get("level")   || "";
  const tName      = params.get("t")       || "";
  const avatarImg  = params.get("avatar")  || "";

  const levelLabel = LEVEL_LABELS[level] || "";
  const nextLevel  = LEVEL_NEXT[level]   || "";
  const progressMsg = nextLevel ? `Through to the ${nextLevel}!` : "Match Winner!";

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg,#06081a 0%,#0a0f2c 50%,#12071a 100%)",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "32px 20px",
      fontFamily: "sans-serif",
    }}>
      {/* Card */}
      <div style={{
        width: "100%", maxWidth: 540,
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(230,57,70,0.3)",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 0 80px rgba(230,57,70,0.15)",
      }}>
        {/* Top banner */}
        <div style={{
          background: "linear-gradient(90deg,#e63946,#c1121f)",
          padding: "10px 24px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <span style={{ fontWeight: 900, fontSize: 18, letterSpacing: "0.15em", color: "#fff", textTransform: "uppercase" }}>
            PROCTORLY
          </span>
          {(tName || levelLabel) && (
            <span style={{ fontSize: 11, color: "rgba(255,255,255,0.8)", letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 600 }}>
              {tName}{tName && levelLabel ? " · " : ""}{levelLabel}
            </span>
          )}
        </div>

        {/* Body: avatar left + text right */}
        <div style={{ display: "flex", alignItems: "stretch", minHeight: 280 }}>
          {/* Avatar */}
          <div style={{ width: 180, flexShrink: 0, position: "relative", overflow: "hidden" }}>
            {avatarImg ? (
              <img src={decodeURIComponent(avatarImg)} alt={name}
                style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center top", display: "block" }} />
            ) : (
              <div style={{ width: "100%", height: "100%", minHeight: 280, background: "rgba(230,57,70,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Trophy style={{ width: 48, height: 48, color: "#e63946" }} />
              </div>
            )}
            {/* Gradient edge */}
            <div style={{
              position: "absolute", top: 0, right: 0, bottom: 0, width: 40,
              background: "linear-gradient(to right, transparent, rgba(10,15,44,0.95))",
              pointerEvents: "none",
            }} />
          </div>

          {/* Text */}
          <div style={{ flex: 1, padding: "28px 24px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div style={{ fontSize: 10, letterSpacing: "0.3em", textTransform: "uppercase", color: "#e63946", fontWeight: 700, marginBottom: 6 }}>
              Match Winner
            </div>
            <div style={{ fontWeight: 900, fontSize: 42, lineHeight: 0.9, textTransform: "uppercase", letterSpacing: "-0.02em", color: "#fff" }}>
              {name}
            </div>
            <div style={{ fontWeight: 900, fontSize: 42, lineHeight: 0.9, textTransform: "uppercase", letterSpacing: "-0.02em", color: "#e63946", marginTop: 2 }}>
              WINS.
            </div>

            {/* Score */}
            <div style={{ marginTop: 18, fontSize: 14, color: "rgba(255,255,255,0.55)", fontWeight: 600, letterSpacing: "0.05em" }}>
              <span style={{ color: "#fff" }}>{name.split(" ")[0]}</span>
              {" "}<span style={{ color: "#e63946", fontWeight: 800 }}>{score}</span>
              <span style={{ color: "rgba(255,255,255,0.25)", margin: "0 6px" }}>·</span>
              <span style={{ color: "#e63946", fontWeight: 800 }}>{oppScore}</span>
              {" "}<span style={{ color: "rgba(255,255,255,0.55)" }}>{oppName.split(" ")[0]}</span>
            </div>

            {/* Progress pill */}
            {nextLevel && (
              <div style={{
                marginTop: 16, display: "inline-flex", alignItems: "center", gap: 6,
                background: "rgba(230,57,70,0.12)",
                border: "1px solid rgba(230,57,70,0.3)",
                borderRadius: 99, padding: "5px 12px",
                fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase",
                color: "#e63946", fontWeight: 700, width: "fit-content",
              }}>
                🏆 {progressMsg}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: "12px 24px",
          borderTop: "1px solid rgba(255,255,255,0.06)",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          background: "rgba(0,0,0,0.2)",
        }}>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: "0.15em", textTransform: "uppercase" }}>
            proctorly.online
          </div>
          <div style={{ fontSize: 10, color: "rgba(255,255,255,0.3)", letterSpacing: "0.1em" }}>
            AI-Powered Battle Quiz
          </div>
        </div>
      </div>

      {/* CTA */}
      <Link to="/"
        style={{
          marginTop: 28, display: "inline-flex", alignItems: "center", gap: 8,
          background: "#e63946", color: "#fff",
          padding: "12px 28px", borderRadius: 8,
          fontWeight: 700, fontSize: 14, letterSpacing: "0.1em",
          textTransform: "uppercase", textDecoration: "none",
        }}>
        Play on Proctorly →
      </Link>
    </div>
  );
}
